import useRouter from 'hooks/useRouter';
import ChargeStationListView from '../../components/ChargeStationListView';

function ChargeStationListScreen(props) {
  // ---- PROPERTIES ----
  const router = useRouter();

  return (
    <div className="container-fluid px-4 my-4">
      <ChargeStationListView />
    </div>
  );
}

export default ChargeStationListScreen;
